import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const accents = [
  { bg: 'bg-primary-50', fg: 'text-primary-600', ring: 'border-primary-200', hover: 'hover:border-primary-400' },
  { bg: 'bg-accent-50', fg: 'text-accent-600', ring: 'border-accent-200', hover: 'hover:border-accent-400' },
  { bg: 'bg-secondary-100', fg: 'text-secondary-900', ring: 'border-secondary-200', hover: 'hover:border-secondary-400' },
];

export default function CategoryEntries() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-12">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat, i) => {
          const a = accents[i % accents.length];
          return (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className={`group flex items-center gap-4 p-5 rounded-lg border bg-background-50 transition-colors cursor-pointer ${a.ring} ${a.hover}`}
            >
              <span className={`w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-lg ${a.bg} ${a.fg} shrink-0`}>
                <i className={`${cat.icon} text-2xl md:text-3xl`} />
              </span>
              <div className="min-w-0">
                <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="mt-1 text-sm text-foreground-500 line-clamp-1">{cat.desc}</p>
                <span className="inline-flex items-center gap-1 mt-2 text-xs text-primary-600">
                  进入分类 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}